export class TokenStorage {
	private static accessToken: string | null = null;
	private static sessionExpiresAt: string | null = null;

	static setAccessToken(token: string): void {
		this.accessToken = token;
	}

	static getAccessToken(): string | null {
		return this.accessToken;
	}

	static clearAccessToken(): void {
		this.accessToken = null;
		this.sessionExpiresAt = null;
	}

	/** Refresh-token expiry reported by the backend; undefined from older responses is stored as null. */
	static setSessionExpiresAt(value: string | null | undefined): void {
		this.sessionExpiresAt = value ?? null;
	}

	static getSessionExpiresAt(): string | null {
		return this.sessionExpiresAt;
	}
}
